import $axios from "../../api";

// MODULE NAME
const module = "/website/promotion-page";

const state = () => ({
    isLoading: false,
    isErrors: "",
    page: 1,
    isSuccess: false,
    list: null,
    detail: null,
    errorForm: {},

    dropdownSectionList: [
        {
            label: "Banner",
            value: "banner",
        },
        {
            label: "Voucher",
            value: "voucher",
        },
        {
            label: "Kategori Produk",
            value: "category_product",
        },
        {
            label: "Daftar Kategori",
            value: "category_list",
        },
    ],

    form: {
        title: "",
        slug: "",
        start_date: "",
        end_date: "",
        slug: "",
        color: "#bc6789",
        colorRgb: "188, 103, 137",
    },

    content: [],

    selectedSections: [],

    previewModal: false,

    voucherModal: false,

    template1: [
        {
            type: "banner_1",
            sectionType: "banner",
            sectionId: `banner_${Date.now()}1`,
            data: [
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
            ],
        },
        {
            type: "voucher_1",
            sectionType: "voucher",
            sectionId: `voucher_${Date.now()}2`,
            title: "Lebih Hemat Pakai Voucher",
            data: [
                {
                    dummy: true,
                    id: 20464,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: null,
                    disc_percentage: 10,
                    min_qty: null,
                    min_transaction: 500000,
                    max_disc_transaction: 200000,
                    start_date: "2023-08-27T17:00:00.000000Z",
                    end_date: "2024-01-30T17:00:00.000000Z",
                },
                {
                    dummy: true,
                    id: 21485,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: null,
                    disc_percentage: 10,
                    min_qty: null,
                    min_transaction: 1500000,
                    max_disc_transaction: 120000,
                    start_date: "2024-02-22T17:00:00.000000Z",
                    end_date: "2024-02-28T17:00:00.000000Z",
                },
                {
                    dummy: true,
                    id: 22348,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: "100000",
                    disc_percentage: null,
                    min_qty: null,
                    min_transaction: 800000,
                    max_disc_transaction: null,
                    start_date: "2024-01-24T17:00:00.000000Z",
                    end_date: "2024-01-30T17:00:00.000000Z",
                },
            ],
        },
        {
            type: "category_product_1",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}3`,
            title: "Special Deals 20%",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-amino-x-224-lb-blue-rasberry-6747c03476cf5.jpeg",
                    sku: "530560",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-amino-x-224-lb-fruit-punch-6747c0603da7a.jpeg",
                    sku: "530558",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-syntha-6-291-lb-cookies-cream-bundle-6711c9c9bd449.jpeg",
                    sku: "530563",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-syntha-6-isolate-bundling-no-explode-245-lb-665d6bd7d7987.jpeg",
                    sku: "530508bundle",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-true-mass-1200-chocolate-1038-lb-67456cca9c91f.jpeg",
                    sku: "530550",
                },
            ],
        },
        {
            type: "category_product_1",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}4`,
            title: "Special Deals 40%",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-amino-energy-270-gr-green-apple-exp-date-10-25-6736f03f39ad8.jpeg",
                    sku: "510144",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-bcaa-1000-400-caps-exp-date-10-25-6731dbad223c5.jpeg",
                    sku: "510013",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-sachet-isolate-chocolate-bliss-31-gr-exp-date-8-24-674ed2fd7c050.jpeg",
                    sku: "510187",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-sachet-plant-chocolate-40-gr-exp-date-7-25-674ed2b840b76.jpeg",
                    sku: "510177",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-whey-gold-standard-2-lb-vanilla-ice-cream-67d18c72070c1.jpeg",
                    sku: "510122",
                },
            ],
        },
        {
            type: "category_list_1",
            sectionType: "category_list",
            sectionId: `category_list_${Date.now()}5`,
            title: "Brand Unggulan untuk Anda",
            data: [
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Bio Oil",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "BSN",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Childlife",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Kyolic",
                },
            ],
        },
        {
            type: "category_product_1",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}6`,
            title: "Rekomendasi Produk Lainnya",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-infusions-088-lb-mango-lime-400g-exp-date-1-25-bundle-677cef820c6ba.jpeg",
                    sku: "510500bundle",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-infusions-088-lb-mixed-berry-400g-exp-date-5-25-6756da4235715.jpeg",
                    sku: "510501",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-low-carb-chocolate-3-lb-exp-date-5-25-6756db1539d90.jpeg",
                    sku: "510506",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-zero-carb-cookies-cream-1-lb-exp-date-10-25-6756db7a6d1d5.jpeg",
                    sku: "510502",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-zero-carb-vanilla-1-lb-6757f6cc5858c.jpeg",
                    sku: "510507",
                },
            ],
        },
        {
            type: "banner_1",
            sectionType: "banner",
            sectionId: `banner_${Date.now()}7`,
            data: [
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
            ],
        },
    ],

    template2: [
        {
            type: "banner_1",
            sectionType: "banner",
            sectionId: `banner_${Date.now()}8`,
            data: [
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
            ],
        },
        {
            type: "voucher_1",
            sectionType: "voucher",
            sectionId: `voucher_${Date.now()}9`,
            title: "Lebih Hemat Pakai Voucher",
            data: [
                {
                    dummy: true,
                    id: 20464,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: null,
                    disc_percentage: 10,
                    min_qty: null,
                    min_transaction: 500000,
                    max_disc_transaction: 200000,
                    start_date: "2023-08-27T17:00:00.000000Z",
                    end_date: "2024-01-30T17:00:00.000000Z",
                },
                {
                    dummy: true,
                    id: 21485,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: null,
                    disc_percentage: 10,
                    min_qty: null,
                    min_transaction: 1500000,
                    max_disc_transaction: 120000,
                    start_date: "2024-02-22T17:00:00.000000Z",
                    end_date: "2024-02-28T17:00:00.000000Z",
                },
                {
                    dummy: true,
                    id: 22348,
                    name: "Dummy Voucher",
                    coupon_code: "DummyVoucher",
                    is_member: 0,
                    promo_type: 1,
                    disc_price: "100000",
                    disc_percentage: null,
                    min_qty: null,
                    min_transaction: 800000,
                    max_disc_transaction: null,
                    start_date: "2024-01-24T17:00:00.000000Z",
                    end_date: "2024-01-30T17:00:00.000000Z",
                },
            ],
        },
        {
            type: "category_product_2",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}10`,
            title: "Special Deals 20%",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-amino-x-224-lb-blue-rasberry-6747c03476cf5.jpeg",
                    sku: "530560",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-amino-x-224-lb-fruit-punch-6747c0603da7a.jpeg",
                    sku: "530558",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-syntha-6-291-lb-cookies-cream-bundle-6711c9c9bd449.jpeg",
                    sku: "530563",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-syntha-6-isolate-bundling-no-explode-245-lb-665d6bd7d7987.jpeg",
                    sku: "530508bundle",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/bsn-true-mass-1200-chocolate-1038-lb-67456cca9c91f.jpeg",
                    sku: "530550",
                },
            ],
        },
        {
            type: "category_product_2",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}11`,
            title: "Special Deals 40%",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-amino-energy-270-gr-green-apple-exp-date-10-25-6736f03f39ad8.jpeg",
                    sku: "510144",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-bcaa-1000-400-caps-exp-date-10-25-6731dbad223c5.jpeg",
                    sku: "510013",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-sachet-isolate-chocolate-bliss-31-gr-exp-date-8-24-674ed2fd7c050.jpeg",
                    sku: "510187",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-sachet-plant-chocolate-40-gr-exp-date-7-25-674ed2b840b76.jpeg",
                    sku: "510177",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/optimum-nutrition-whey-gold-standard-2-lb-vanilla-ice-cream-67d18c72070c1.jpeg",
                    sku: "510122",
                },
            ],
        },
        {
            type: "category_list_2",
            sectionType: "category_list",
            sectionId: `category_list_${Date.now()}12`,
            title: "Tentukan Kebutuhan Anda",
            data: [
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Children’s Health",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Herbs & Natural Remedies",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Joint & Bone",
                },
                {
                    dummy: true,
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-2-55-1758769540.png",
                    image_id: "dummy",
                    link: "/brand",
                    title: "Women Health",
                },
            ],
        },
        {
            type: "category_product_2",
            sectionType: "category_product",
            sectionId: `category_product_${Date.now()}13`,
            title: "Rekomendasi Produk Lainnya",
            data: [
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-infusions-088-lb-mango-lime-400g-exp-date-1-25-bundle-677cef820c6ba.jpeg",
                    sku: "510500bundle",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-infusions-088-lb-mixed-berry-400g-exp-date-5-25-6756da4235715.jpeg",
                    sku: "510501",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-low-carb-chocolate-3-lb-exp-date-5-25-6756db1539d90.jpeg",
                    sku: "510506",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-zero-carb-cookies-cream-1-lb-exp-date-10-25-6756db7a6d1d5.jpeg",
                    sku: "510502",
                },
                {
                    dummy: true,
                    brand: "Dummy",
                    product_name: "Dummy Product",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/products/isopure-zero-carb-vanilla-1-lb-6757f6cc5858c.jpeg",
                    sku: "510507",
                },
            ],
        },
        {
            type: "banner_1",
            sectionType: "banner",
            sectionId: `banner_${Date.now()}14`,
            data: [
                {
                    dummy: true,
                    image_id: "dummy",
                    image: "https://naturalfarm.sgp1.cdn.digitaloceanspaces.com/uploads/imagestorage/img-dummy-89-1758769428.png",
                    link: "/sale",
                },
            ],
        },
    ],

    templateSelected: null,
});

const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    ASSIGN_ERRORS(state, payload) {
        state.isErrors = payload;
    },
    ASSIGN_ERROR_FORM(state, payload) {
        state.errorForm = payload;
    },
    SET_PAGE(state, payload) {
        state.page = payload;
    },
    SET_IS_SUCCESS(state, payload) {
        state.isSuccess = payload;
    },
    SET_LIST(state, payload) {
        state.list = payload;
    },
    SET_DETAIL(state, payload) {
        state.detail = payload;
    },
    SET_PREVIEW_MODAL(state, payload) {
        state.previewModal = payload;
    },
    SET_VOUCHER_MODAL(state, payload) {
        state.voucherModal = payload;
    },
    SET_TEMPLATE_SELECTED(state, payload) {
        state.templateSelected = payload;
    },
    SET_FORM(state, payload) {
        state.form[payload.key] = payload.value;
    },
    CLEAR_FORM(state) {
        state.form = {
            title: "",
            slug: "",
            start_date: "",
            end_date: "",
            slug: "",
            color: "#bc6789",
            colorRgb: "188, 103, 137",
        };
    },
    SET_CONTENT(state, payload) {
        state.content.push(...payload);
    },
    UPSERT_CONTENT(state, payload) {
        const idx = state.content.findIndex(
            (c) => c.sectionId === payload.sectionId
        );
        if (idx > -1) {
            state.content.splice(idx, 1, payload);
        } else {
            state.content.push(payload);
        }
    },
    CLEAR_CONTENT(state) {
        state.content = [];
    },
    ADD_SECTION(state, payload) {
        state.selectedSections.push(payload);
    },
    REMOVE_SECTION(state, payload) {
        state.selectedSections = state.selectedSections.filter(
            (s) => s.sectionId !== payload
        );
        state.content = state.content.filter((c) => c.sectionId !== payload);

        state.errorForm = {}
        state.isErrors = ''
    },
    MOVE_SECTION_UP(state, payload) {
        const idx = state.selectedSections.findIndex(
            (s) => s.sectionId === payload
        );
        if (idx > 0) {
            const item = state.selectedSections.splice(idx, 1)[0];
            state.selectedSections.splice(idx - 1, 0, item);

            const cIdx = state.content.findIndex((c) => c.sectionId === payload);
            if (cIdx > 0) {
                const cItem = state.content.splice(cIdx, 1)[0];
                state.content.splice(cIdx - 1, 0, cItem);
            }
        }

        state.errorForm = {}
        state.isErrors = ''
    },
    MOVE_SECTION_DOWN(state, payload) {
        const idx = state.selectedSections.findIndex(
            (s) => s.sectionId === payload
        );
        if (idx > -1 && idx < state.selectedSections.length - 1) {
            const item = state.selectedSections.splice(idx, 1)[0];
            state.selectedSections.splice(idx + 1, 0, item);

            const cIdx = state.content.findIndex((c) => c.sectionId === payload);
            if (cIdx > -1 && cIdx < state.content.length - 1) {
                const cItem = state.content.splice(cIdx, 1)[0];
                state.content.splice(cIdx + 1, 0, cItem);
            }
        }

        state.errorForm = {}
        state.isErrors = ''
    },
    CLEAR_SECTIONS(state) {
        state.selectedSections = [];
        state.errorForm = {}
        state.isErrors = ''
    },
};

const actions = {
    getList({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(
                    `${module}/list?page=${state.page}&view=${
                        rootState.Main.view
                    }${payload || ""}`
                )
                .then((res) => {
                    commit("SET_LIST", res.data.data);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    getDetail({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        return new Promise((resolve, reject) => {
            $axios
                .get(`${module}/view?id=${payload}`)
                .then((res) => {
                    commit("SET_DETAIL", res.data.data);
                    commit("SET_LOADING", false);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    create({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        commit("ASSIGN_ERROR_FORM", {});
        commit("ASSIGN_ERRORS", "");

        return new Promise((resolve, reject) => {
            $axios
                .post(`${module}/create`, payload)
                .then((res) => {    
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);

                    commit("ASSIGN_ERRORS", error.response.data.errors);
                    commit("SET_LOADING", false);

                    if(error.response.status == 422){
                        commit("ASSIGN_ERROR_FORM", error.response.data.errors);
                    }

                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    update({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .put(`${module}/update`, payload)
                .then((res) => {
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                })
                .catch((error) => {
                    commit("ASSIGN_ERRORS", error.response.data.errors);
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    showHide({ commit, state, rootState, dispatch }, payload) {
        commit("SET_LOADING", true);
        commit("SET_IS_SUCCESS", false);
        return new Promise((resolve, reject) => {
            $axios
                .post(`${module}/showhide`, { id: payload })
                .then((res) => {
                    commit("SET_IS_SUCCESS", true);
                    commit("SET_LOADING", false);
                    resolve(res);
                })
                .catch((error) => {
                    reject(error);
                    commit("SET_LOADING", false);
                    dispatch("Main/globalSweetAlert", error.response, {
                        root: true,
                    });
                });
        });
    },
    clearALLTemplate({ commit }) {
        commit("CLEAR_FORM");
        commit("CLEAR_CONTENT");
        commit("CLEAR_SECTIONS");
        commit("SET_TEMPLATE_SELECTED", null);
    },
    clearTemplate({ commit }) {
        commit("CLEAR_CONTENT");
        commit("CLEAR_SECTIONS");
        commit("SET_TEMPLATE_SELECTED", null);
    },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
